import React from 'react';
import CollectionsDetailsTable from '../../../components/Transactions/Collections/CollectionsDetailsTable';
import ContentView from '../../../components/Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <CollectionsDetailsTable />
        </ContentView>
    );
};
export default index;
